import http from "../http-common";

class TagService {
// Tags
  //Create new tag
  createNewTag = (data) => http.post('/tag', data);

  //update tag
  updateTag = (tag_id,data)=>http.put(`/tag/${tag_id}`,data);

  //delete tag
  deleteTag = (tag_id)=>http.delete(`/tag/${tag_id}`);

  //get tags
  getTags = () => http.get(`/tag`);

  //tags for contact
  //add tag for contact
  addTagforContact = (data) => http.post(`/contact_tags`,data);

  //remove tag for contact
  removeTagforContact = (contact_id,tag_id) => http.delete(`/contact_tags/${contact_id}/tag_id/${tag_id}`);
  
  isTagEditable = (tag_id) => http.get(`/tag/edit/${tag_id}`);

  applyMassTagforContact = (data) => http.post(`/masstag`,data);

  //Conversation Tag
  addConversationTag = (data) => http.post(`/conversation_tag`,data);

  removeConversationTag = (conversation_id, tag_id) => http.delete(`/conversation_tag/conversation_id/${conversation_id}/tag_id/${tag_id}`);

  addConvoTag =(data) => http.post(`/convo_tag`,data);

  removeConvoTag =(data) =>http.delete(`/convo_tag/convodetails?q=${encodeURIComponent(JSON.stringify(data))}`);

  // OSClaims conversation-level tags
  addOsclaimsTag = (data) => http.post(`/osclaims_tag`, data);

  removeOsclaimsTag = (convo_id, tag_id) => http.delete(`/osclaims_tag/convo_id/${convo_id}/tag_id/${tag_id}`);

  // AI icon suggestion
  suggestIcons = (description, tag_source) => http.post(`/tag/suggest-icons`, { description, tag_source });
}
export default new TagService();